// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1-j9k","author":"Table_author__2goY2","authorImage":"Table_authorImage__2fXxE","unreadRow":"Table_unreadRow__3dJeL"};